import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid2';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import SettingsSuggestRoundedIcon from '@mui/icons-material/SettingsSuggestRounded';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded';
import { useLanguage } from '../contexts/LanguageContext';  // ✅ Import translations

export default function Highlights() {
  const { translations } = useLanguage();  // ✅ Use translations from context
  const highlights = translations.highlights_section;

  // ✅ Use translated text dynamically
  const items = [
    { icon: <SettingsSuggestRoundedIcon />, title: highlights.adaptable_performance_title, description: highlights.adaptable_performance_description },
    { icon: <ConstructionRoundedIcon />, title: highlights.built_to_last_title, description: highlights.built_to_last_description },
    { icon: <ThumbUpAltRoundedIcon />, title: highlights.great_user_experience_title, description: highlights.great_user_experience_description },
    { icon: <AutoFixHighRoundedIcon />, title: highlights.innovative_functionality_title, description: highlights.innovative_functionality_description },
    { icon: <SupportAgentRoundedIcon />, title: highlights.reliable_support_title, description: highlights.reliable_support_description },
    { icon: <QueryStatsRoundedIcon />, title: highlights.precision_detail_title, description: highlights.precision_detail_description }
  ];

  return (
    <Box
      id="highlights"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
      }}
    >
      <Container
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { xs: 3, sm: 6 },
        }}
      >
        <Box
          sx={{
            width: { sm: '100%', md: '60%' },
            textAlign: { sm: 'left', md: 'center' },
          }}
        >
          <Typography
            component="h2"
            variant="h4"
            gutterBottom
            sx={{ color: 'text.primary' }}
          >
            {highlights.title}  {/* ✅ Localized title */}
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            {highlights.description}  {/* ✅ Localized description */}
          </Typography>
        </Box>
        <Grid container spacing={2}>
          {items.map((item, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
              <Stack
                direction="column"
                component={Card}
                spacing={1}
                useFlexGap
                sx={{
                  color: 'inherit',
                  p: 3,
                  height: '100%',
                  borderColor: 'hsla(220, 25%, 25%, 0.3)',
                }}
              >
                <Box sx={{ opacity: '50%' }}>{item.icon}</Box>
                <div>
                  <Typography gutterBottom sx={{ fontWeight: 'medium' }}>
                    {item.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'grey.400' }}>
                    {item.description}
                  </Typography>
                </div>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
